import { render, staticRenderFns } from "./PlanDetail.vue?vue&type=template&id=a59d7c54&scoped=true"
import script from "./PlanDetail.vue?vue&type=script&lang=js"
export * from "./PlanDetail.vue?vue&type=script&lang=js"
import style0 from "./PlanDetail.vue?vue&type=style&index=0&id=a59d7c54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59d7c54",
  null
  
)

export default component.exports